import React, { useState, useEffect } from "react";
import { ModalFormCreateGroup } from "../components/ModalFormCreateGroup";
import { InfoCards } from "../components/InfoCards";
import { AlertUserSessionExpiredToken } from "../components/AlertUserSessionExpiredToken";
import { useParams } from "react-router-dom";
import { FormCreateGroup } from "../containers/FormCreateGroup";

function PageFormCreateGroup() {
	const params = useParams();
	const isEditingGroup = Boolean(params.id);

	useEffect(() => {
		if (params.id) {
			setModalInfoCreateNewGroup(false);
		}
	}, [params.id]);

	const [modalInfoCreateNewGroup, setModalInfoCreateNewGroup] = useState(true);
	const handleClickModalInfoCreateNewGroup = () =>
		setModalInfoCreateNewGroup(!modalInfoCreateNewGroup);

	return (
		<React.Fragment>
			<AlertUserSessionExpiredToken />
			<div className='container group-builder-page'>
				<section className='group-builder-hero card border-0'>
					<div className='card-body'>
						<p className='groups-page-eyebrow mb-2'>
							{isEditingGroup ? "Gestion del grupo" : "Nuevo espacio de juego"}
						</p>
						<h1 className='group-builder-title mb-3'>
							{isEditingGroup
								? "Edita la configuracion del grupo"
								: "Crea un grupo claro, rapido y facil de invitar"}
						</h1>
						<p className='group-builder-copy mb-0'>
							Arma el grupo alrededor de un campeonato, define las reglas y deja
							listo un espacio privado para que todos entren a pronosticar.
						</p>
					</div>
				</section>

				<div className='group-builder-shell mt-4'>
					<div className='card border-0 group-builder-card'>
						<div className='card-body'>
							<FormCreateGroup />
						</div>
					</div>
					<InfoCards />
				</div>
			</div>
			{modalInfoCreateNewGroup && (
				<ModalFormCreateGroup
					handleClickModalInfoCreateNewGroup={
						handleClickModalInfoCreateNewGroup
					}
				/>
			)}
		</React.Fragment>
	);
}

export { PageFormCreateGroup };
